import React from 'react';

export interface FinalizePaneProps {}

export default function FinalizePane(props: FinalizePaneProps): JSX.Element {
  return (
    <div>
      <h3>Finalize</h3>
      <p>
        Optionally define project folder and studies to finalize creation of antibody and component entities.
      </p>

      <div>
        <h4>Entities to Create</h4>
        <p>Total entity count will be shown for each of the following entity types:</p>
        <ul>
          <li>DNA domains</li>
          <li>AA domains</li>
          <li>AA chains</li>
          <li>Antibodies</li>
        </ul>
      </div>

      <div>
        <h4>Output Settings</h4>
        <p>Configure where to save the created entities.</p>
        <div>
          <p>Output folder selection will go here</p>
        </div>
      </div>
    </div>
  );
}
